import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/wissen/kurse")({
  component: () => <Outlet />,
});
